import {
    Library, Brain, BookOpen, FlaskConical, Scale, Stethoscope, Code2, Atom,
    Calculator, GraduationCap, FolderOpen, Layers, Globe2, Landmark,
} from "lucide-react";

// Visual identity for a workspace. Kept small + premium; names map to lucide icons.
export const WS_ICONS = {
    library: Library, brain: Brain, book: BookOpen, flask: FlaskConical,
    scale: Scale, stethoscope: Stethoscope, code: Code2, atom: Atom,
    calculator: Calculator, graduation: GraduationCap, folder: FolderOpen,
    layers: Layers, globe: Globe2, landmark: Landmark,
};

export const WS_ICON_ORDER = [
    "library", "brain", "stethoscope", "scale", "flask", "atom", "calculator",
    "code", "book", "graduation", "globe", "landmark", "layers", "folder",
];

// Accent colors (solid hsl) — dominant color with sharp accent per design system.
export const WS_COLORS = {
    violet: "hsl(258,70%,64%)",
    emerald: "hsl(152,52%,46%)",
    blue: "hsl(206,70%,52%)",
    amber: "hsl(38,92%,58%)",
    rose: "hsl(342,72%,60%)",
    teal: "hsl(174,72%,46%)",
    cyan: "hsl(190,80%,52%)",
    orange: "hsl(24,90%,58%)",
};

export const WS_COLOR_ORDER = ["violet", "emerald", "blue", "amber", "rose", "teal", "cyan", "orange"];

export const iconFor = (name) => WS_ICONS[name] || Library;
export const accentFor = (color) => WS_COLORS[color] || WS_COLORS.violet;
